import { i18N } from "../helper";
AC_SERVICES.addListener('Editing.Editables.Ready', (Editables) => {
    const Abstract = Editables.get('_abstract');
    class Stock extends Abstract {
        getEditableType() {
            return 'wc_stock';
        }
        focus() {
            this.getTypeElement().focus();
        }
        render() {
            let typeElement = this.getTypeElement();
            for (let key in acp_woocommerce_vars.stock_status_options) {
                typeElement.append(new Option(acp_woocommerce_vars.stock_status_options[key], key));
            }
            typeElement.addEventListener('change', () => {
                this.initState();
            });
            this.initState();
            if (!this.settings.manage_stock) {
                this.toggleManageStock(false);
            }
            this.getReplaceTypeElement().addEventListener('change', () => {
                this.getQuantityElement().value = '';
            });
        }
        valueToInput(value) {
            if (!value) {
                return;
            }
            this.getTypeElement().value = value.type;
            this.getQuantityElement().value = value.quantity;
            this.initState();
        }
        getValue() {
            return {
                type: this.getTypeElement().value,
                quantity: this.getQuantityElement().value,
                replace_type: this.getReplaceTypeElement().value,
            };
        }
        toggleManageStock(enable = true) {
            let input = this.getTypeElement().querySelector('option[value=manage_stock]');
            if (enable) {
                input.removeAttribute('disabled');
                if (this.getTypeElement().value === input.value) {
                }
            }
            else {
                input.setAttribute('disabled', 'disabled');
            }
            this.initState();
        }
        initState() {
            this.toggleQuantitySection(this.getTypeElement().value === 'manage_stock');
        }
        getTypeElement() {
            return this.getElement().querySelector('[name=stock_type]');
        }
        getReplaceTypeElement() {
            return this.getElement().querySelector('[name=replace_type]');
        }
        getQuantityElement() {
            return this.getElement().querySelector('[name=quantity]');
        }
        toggleQuantitySection(display = true) {
            this.getElement().querySelector('.input__section.-quantity').style.display = display ? 'block' : 'none';
        }
        getTemplate() {
            const quantity = this.getEditableTemplate().getFormHelper().input('quantity', null, {
                type: 'number',
                'step': 'any',
                'min': 0
            }).outerHTML;
            return `
			<div class="aceditable__form__inputs__stock">
				<select name="stock_type">
					<option value="manage_stock">${i18N().manage_stock}</option>
				</select>
				
				<div class="input__section -quantity">
					<div class="input__divider">
						<span class="input__divider__label">Stock Quantity</span>
						<div class="input__divider__line"></div>
					</div>
					<div class="input__group -stock">
						<div class="input__controlgroup -replace">
							<select name="replace_type">
								<option value="replace">${i18N().replace}</option>
								<option value="increase">${i18N().increase_by}</option>
								<option value="decrease">${i18N().decrease_by}</option>
							</select>
						</div>
						<div class="input__controlgroup -quantity">
							${quantity}
						</div>
					</div> 
				</div>
			</div>
			`;
        }
    }
    Editables.registerEditable('wc_stock', Stock);
});
AC_SERVICES.addListener('Editing.Middleware.Ready', (Middleware) => {
    const Abstract = Middleware.getClass('_abstract');
    class Stock extends Abstract {
        getEditable() {
            return this.Editables.get('wc_stock');
        }
        map() {
            this.args.manage_stock = this.settings.manage_stock;
            return this.args;
        }
    }
    Middleware.register('wc_stock', Stock);
});
